import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

/* ================================================================= */
/* BEGIN: routes                                                     */
/* ================================================================= */
const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: {
      title: 'Nehlueun',
      metaTags: [
        {
          name: 'description',
          content: 'Une plateforme de formation du nehlueun.'
        }
      ]
    }
  },

  {
    path: '/recherche/',
    name: 'Recherche',
    component: () => import('@/views/Recherche.vue'),
    meta: {
      title: 'Recherche'
    }
  },

  {
    path: '/recherche/:search',
    component: () => import('@/views/Recherche.vue'),
    meta: {
      title: 'Recherche'
    }
  },

  {
    path: '/questions',
    name: 'Questions',
    component: () => import('@/views/Questions.vue'),
    meta: {
      title: 'Questions'
    }
  },
  {
    path: '/apprentissage',
    name: 'Apprentissage',
    component: () => import('@/views/Apprentissage.vue'),
    meta: {
      title: 'Apprentissage'
    }
  },
  {
    path: '/evaluation',
    name: 'Evaluation',
    component: () => import('@/views/Evaluation.vue'),
    meta: {
      title: 'Évaluation'
    }
  },
  {
    path: '/capsules-culturelles',
    name: 'CapsulesCulturelles',
    component: () => import('@/views/CapsulesCulturelles.vue'),
    meta: {
      title: 'Capsules culturelles',
      metaTags: [
        {
          name: 'description',
          content: 'Capsules culturelles du nehlueun et de la communauté.'
        }
      ]
    }
  },
  {
    path: '/aide',
    name: 'Aide',
    component: () => import('@/views/Aide.vue'),
    meta: {
      title: 'Aide',
      metaTags: [
        {
          name: 'description',
          content: 'Aide.'
        }
      ]
    }
  },
  {
    path: '/animation',
    name: 'Animation',
    component: () => import('@/views/Animations.vue'),
    meta: {
      title: 'Animation',
      metaTags: [
        {
          name: 'description',
          content: 'Animation.'
        }
      ]
    }
  },

  {
    path: '/inscription',
    name: 'Inscription',
    component: () => import('@/views/Inscription.vue'),
    meta: {
      title: 'Inscription',
      metaTags: [
        {
          name: 'description',
          content: 'Inscription à la plateforme de formation du nehlueun.'
        }
      ]
    }
  },
  {
    path: '/connexion',
    name: 'Connexion',
    component: () => import('@/views/Connexion.vue'),
    meta: {
      title: 'Connexion',
      metaTags: [
        {
          name: 'description',
          content: 'Connexion à la plateforme de formation du nehlueun.'
        }
      ]
    }
  },
  {
    path: '/profil',
    name: 'Profil',
    component: () => import('@/views/Profil.vue'),
    meta: {
      title: 'Profil',
      metaTags: [
        {
          name: 'description',
          content: 'Profil de l\'utilisateur.'
        }
      ]
    }
  },
  {
    path: '/lexique/:module/:title',
    name: 'Lexique',
    component: () => import('@/views/Lexique.vue'),
    meta: {
      title: 'Lexique',
      metaTags: [
        {
          name: 'description',
          content: 'Lexique.'
        }
      ]
    }
  },
  /* --- ERROR 404 --- */
  {
    path: '/*',
    component: () => import('@/views/404.vue'),
    meta: {
      title: 'Page introuvable'
    }
  }
]
/* ================================================================= */
/* END: routes                                                       */
/* ================================================================= */

const router = new VueRouter({
  mode: process.env.CORDOVA_PLATFORM ? 'hash' : 'history',
  base: process.env.CORDOVA_PLATFORM ? process.env.BASE_URL : process.env.BASE_URL + 'app/',
  fallback: true,
  routes
})
/* ================================================================= */
/* BEGIN: get and set metadata                                       */
/* ================================================================= */
router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags)
  if (nearestWithTitle) {document.title = nearestWithTitle.meta.title}
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el))
  if (!nearestWithMeta) {return next()}
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta')
    Object.keys(tagDef).forEach(key => {tag.setAttribute(key, tagDef[key])})
    tag.setAttribute('data-vue-router-controlled', '')
    return tag
  }).forEach(tag => document.head.appendChild(tag))
  next()
})
/* ================================================================= */
/* end: get and set metadata                                         */
/* ================================================================= */
export default router